<mat-card-header>
  @if (image) {
    <div mat-card-avatar [ngStyle]="{ 'background-image': 'url(' + image + ')', 'background-size': 'cover' }"></div>
  }
  <mat-card-title>
    @if (icon) {
      <i [className]="icon"></i>
    }
    {{ icon ? ' ' + title : title }}
  </mat-card-title>
  @if (subtitle) {
    <mat-card-subtitle [innerText]="subtitle"></mat-card-subtitle>
  }
</mat-card-header>
